var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import LanguageSwitch from '@/components/language-switch/LanguageSwitch';
import { identifyApplication, identifyHostname, isLocal } from '@/support/Client';
import LoaderCard from '@/components/loader-card/LoaderCard';
import MfaInput from '@/components/MfaInput/MfaInput';
import { RouteNameEnum } from '@/router/RouteName';
import { logGuard } from '@/router/helpers';
import { Auth } from '@/support/Auth';
import { RolesEnum } from '@/items/Roles';
let Login = class Login extends Vue {
    constructor() {
        super(...arguments);
        this.oAuthClientId = 1;
        this.oAuthSecret = 'secret';
        this.oAuthScope = '*';
        this.email = '';
        this.password = '';
        this.mfaToken = null;
        this.isLoading = false;
        this.valid = false;
        this.emailRules = [
            (v) => !!v || 'Email is required',
            (v) => /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(v) ||
                'E-mail must be valid',
        ];
        this.passwordRules = [(v) => !!v || 'Password is required'];
        this.errorMessage = '';
        this.hasMfa = false;
    }
    mounted() {
        logGuard('[LOGIN] mounted');
        // this.$pageTitle = this.$t('auth.login').toString();
        // this.$route.name === 'logout' ? this.logout() : null;
        // this.verifyHost();
    }
    toggleMfa() {
        this.hasMfa = !this.hasMfa;
    }
    login() {
        logGuard('[LOGIN] starting login');
        this.isLoading = true;
        const payload = {
            username: this.email,
            password: this.password,
            grant_type: 'password',
            client_id: this.oAuthClientId,
            client_secret: this.oAuthSecret,
            scope: this.oAuthScope,
            ...(this.mfaToken ? { mfa_token: `${this.mfaToken}` } : {}),
        };
        Auth.login(payload)
            .then(async (user) => {
            logGuard(user);
            logGuard('[LOGIN] handling current user');
            if (!user) {
                logGuard('[LOGIN] No user found');
                throw Error('Upssie!');
            }
            if (user.hasRole([RolesEnum.ADMIN, RolesEnum.TRAINER, RolesEnum.MANAGER, RolesEnum.ROOT])) {
                logGuard(`[LOGIN] Attempting authenticate user ${user.name}(${user.id})`);
                // await new GlobalUser().authenticate();
            }
            await Promise.all([
                this.$store.dispatch('setIsStoreInitialized', false),
                this.$store.dispatch('userAuthenticated', user),
            ]);
            logGuard('[LOGIN] starting redirect');
            this.redirect();
        })
            .catch(async (error) => {
            const mfaRequiredAndNotSet = !!(error &&
                error.response &&
                error.response.headers &&
                error.response.headers['x-missing-mfa-token'] === '1');
            if (mfaRequiredAndNotSet) {
                await this.$router.push({ name: RouteNameEnum.SET_MFA }).catch(() => { });
            }
            const errorStatus = error && error.response && error.response.status ? error.response.status : undefined;
            const errorMessage = error && error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : undefined;
            this.errorMessage = errorMessage;
            logGuard('[LOGIN] error', errorStatus, errorMessage);
            this.isLoading = false;
        });
    }
    async logout() {
        await this.$store.dispatch('userDeauthenticated');
        this.$router.push({ name: RouteNameEnum.LOGIN });
    }
    redirect() {
        if (this.$route.query.redirect) {
            this.$router.push(this.$route.query.redirect);
        }
        else {
            this.$router.push({ name: RouteNameEnum.HOME });
        }
    }
    /**
     * Verifies if a specific school exists or not.
     */
    verifyHost() {
        const headers = {};
        if (isLocal()) {
            headers['X-Application'] = identifyApplication();
        }
        const client = axios.create({
            baseURL: identifyHostname(),
            headers,
        });
        client.get('/v3/ping').catch((error) => {
            this.$router.push('/invalid');
        });
    }
    beforeCreated() {
        logGuard('[LOGIN] beforeCreated');
    }
    created() {
        logGuard('[LOGIN] created');
    }
};
Login = __decorate([
    Component({
        components: {
            LanguageSwitch,
            LoaderCard,
            MfaInput,
        },
    })
], Login);
export default Login;
